import type { ComponentType } from "react";
import { Navigate } from "react-router";

import { useAuth } from "@/hooks/use-auth.ts";

// if a user is logged in, and their role well idk what this does, TODO: figure this out
export function withGuest(Component: ComponentType) {
    return function GuestGuarded() {
        const { role } = useAuth();

        if (role !== "unassigned" && role !== "admin") {
            // already logged in → send them somewhere else
            return <Navigate to="/" replace />;
        }

        return <Component />;
    };
}
